import React from "react"
import { useLocation } from "react-router-dom"

import FormContainer from "../../components/FormContainer"
import Layout from "../../components/PublicLayout"

export default function Error() {
  const path = useLocation().pathname

  return (
    <Layout title="Error: 404">
      <FormContainer>
        <h1 id="server-modal-title">We couldn't find a match for</h1>
        <code>{path}</code>
      </FormContainer>
    </Layout>
  )
}
